// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import phoneIcon from "@/assets/icons/phone.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type PhoneIconProps = Omit<IconProps, "name">;

export function PhoneIcon(props: PhoneIconProps): React.ReactNode {
  return <Icon name={phoneIcon} {...props} />;
}
